import { createFileRoute, Navigate } from '@tanstack/react-router';

export const Route = createFileRoute('/_auth/patient-transport/')({
  component: () => <Navigate to="/patient-transport/fares" />,
  beforeLoad: ({ context }) => {
    if (!context.userAppContext.app) {
      context.userAppContext.storeApp('porter');
    }
  },
});
